import {KontaktState} from '../states/kontakt.state';
import {createReducer, on} from '@ngrx/store';
import {KontaktActions} from '../actions/kontakt.actions';
import {FakturierungsbelegFormActions} from '../actions/fakturierungsbeleg-form.actions';


/**
 * Seitengroesse der Kontaktauswahl. Zugleich die Mindestanzahl an auswaehlbaren
 * Kontakten, bis zu der der Nachlade-Effect weitere Seiten anfordert.
 */
export const KONTAKT_PAGE_SIZE = 15;

export const initialKontaktState: KontaktState = {
  displayedIds: [],
  filterDto: {},
  pageableDto: {
    size: KONTAKT_PAGE_SIZE,
    number: 0,
  },
  readMoreKunden: false,
  loading: false,
  hasMorePages: true,
};

/**
 * Die API liefert keine Typ-Filterung; ob noch Seiten folgen, ergibt sich daraus,
 * ob die zuletzt gelieferte Seite voll war.
 */
const hasMorePages = (state: KontaktState, geliefert: number): boolean =>
  geliefert >= (state.pageableDto.size ?? KONTAKT_PAGE_SIZE);

export const kontaktReducer = createReducer(
  initialKontaktState,

  on(
    KontaktActions.readKunden,
    KontaktActions.readMoreKunden,
    (state) => ({
      ...state,
      loading: true,
    }),
  ),

  on(
    KontaktActions.setDisplayedIds,
    (state, {kundeDtos}) => ({
      ...state,
      displayedIds: kundeDtos.map(kundeDto => kundeDto.id!),
      loading: false,
      hasMorePages: hasMorePages(state, kundeDtos.length),
    }),
  ),

  on(
    KontaktActions.addDisplayedIds,
    (state, {kundeDtos}) => ({
      ...state,
      displayedIds: [
        ...state.displayedIds,
        ...kundeDtos.map(kundeDto => kundeDto.id!),
      ],
      loading: false,
      hasMorePages: hasMorePages(state, kundeDtos.length),
    }),
  ),

  on(KontaktActions.clearDisplayedKunden,
    (state) => ({
      ...state,
      displayedIds: [],
      loading: false,
      hasMorePages: false,
    }),
  ),

  on(KontaktActions.addDisplayedId, (state, {kundeId}) => {
    let updatedDisplayedIds = [...state.displayedIds];
    if (!updatedDisplayedIds.includes(kundeId!)) {
      updatedDisplayedIds = [
        ...updatedDisplayedIds,
        kundeId!,
      ];
    }

    return {
      ...state,
      displayedIds: updatedDisplayedIds,
    };
  }),

  on(FakturierungsbelegFormActions.changeKontaktMode, (state, {mode}) => {
    if (mode === 'display') {
      return {
        ...state,
        readMoreKunden: false,
        hasMorePages: true,
        filterDto: {
          ...initialKontaktState.filterDto,
        },
        pageableDto: {
          ...initialKontaktState.pageableDto,
        },
      };
    }

    return {
      ...state,
    };
  }),

  on(KontaktActions.triggerReadMoreKunden, (state) => {
    return {
      ...state,
      readMoreKunden: true,
      pageableDto: {
        ...state.pageableDto,
        number: (state.pageableDto.number || 0) + 1,
      },
    };
  }),


  on(KontaktActions.updateTextFilter, (state, {textFilter}) => {
    return {
      ...state,
      readMoreKunden: false,
      hasMorePages: true,
      filterDto: {
        name: textFilter,
      },
      pageableDto: {
        ...initialKontaktState.pageableDto,
      }
    };
  })
);
